import apiClient from '@u/apiClient'
import GetDossierAddressesController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierAddressesController'

export default {
  //region fetch

  async fetchAddressesByDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDossierAddressesController.get({ dossier: payload.dossier_id })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  }
  //endregion
}
